import React, { useState, useEffect } from "react";
import cn from "classnames";
import styles from "./Settings.module.sass";
import Dropdown from "../../../components/Dropdown";
import Checkbox from "../../../components/Checkbox";
import { getFormations } from "../../../services/formation.service";

// Options statiques
const sortingOptions = ["Plus récents", "Plus anciens"];
const justificationOptions = ["Justifiée", "Non justifiée"];

const Settings = ({ onFiltersChange }) => {
  // États des filtres
  const [sorting, setSorting] = useState(sortingOptions[0]);
  const [selectedFormation, setSelectedFormation] = useState("Toutes les formations");
  const [selectedJustifications, setSelectedJustifications] = useState([]);
  
  // État pour les formations dynamiques
  const [formationOptions, setFormationOptions] = useState([]);
  const [loadingFormations, setLoadingFormations] = useState(true);

  // Charger les formations au montage
  useEffect(() => {
    const loadFormations = async () => {
      try {
        setLoadingFormations(true);
        const formations = await getFormations();
        const options = formations.map(f => ({
          id: f.id,
          label: f.exact_title_of_qualification || f.qualification_title || "Formation sans titre"
        }));
        setFormationOptions(options);
      } catch (error) {
        console.error("Erreur lors du chargement des formations:", error);
      } finally {
        setLoadingFormations(false);
      }
    };
    loadFormations();
  }, []);

  // Gestionnaire pour les justifications
  const handleJustificationChange = (justification) => {
    const newJustifications = selectedJustifications.includes(justification)
      ? selectedJustifications.filter(j => j !== justification)
      : [...selectedJustifications, justification];
    setSelectedJustifications(newJustifications);
  };

  // Réinitialiser les filtres
  const resetFilters = () => {
    setSorting(sortingOptions[0]);
    setSelectedFormation("Toutes les formations");
    setSelectedJustifications([]);
    
    if (onFiltersChange) {
      onFiltersChange({
        sorting: sortingOptions[0],
        formationId: null,
        justifications: []
      });
    }
  };

  // Appliquer les filtres
  const applyFilters = () => {
    // Trouver l'ID de la formation sélectionnée
    const formation = formationOptions.find(f => f.label === selectedFormation);
    const formationId = formation ? formation.id : null;
    
    if (onFiltersChange) {
      onFiltersChange({
        sorting,
        formationId,
        justifications: selectedJustifications
      });
    }
  };

  // Préparer les options du dropdown formations
  const formationDropdownOptions = [
    "Toutes les formations",
    ...formationOptions.map(f => f.label)
  ];

  return (
    <div className={styles.settings}>
      <div className={styles.group}>
        {/* Tri */}
        <div className={styles.item}>
          <Dropdown
            className={styles.dropdown}
            classDropdownLabel={styles.label}
            value={sorting}
            setValue={setSorting}
            options={sortingOptions}
            label="Trier par"
          />
        </div>

        {/* Formation */}
        <div className={styles.item}>
          <Dropdown
            className={styles.dropdown}
            classDropdownLabel={styles.label}
            value={loadingFormations ? "Chargement..." : selectedFormation}
            setValue={setSelectedFormation}
            options={loadingFormations ? ["Chargement..."] : formationDropdownOptions}
            label="Formation"
          />
        </div>

        {/* Justification */}
        <div className={styles.item}>
          <div className={styles.label}>Justification</div>
          <div className={styles.list}>
            {justificationOptions.map((justification, index) => (
              <Checkbox
                className={styles.checkbox}
                content={justification}
                value={selectedJustifications.includes(justification)}
                onChange={() => handleJustificationChange(justification)}
                key={index}
                reverse
              />
            ))}
          </div>
        </div>

        {/* Boutons */}
        <div className={styles.btns}>
          <button 
            className={cn("button-stroke", styles.button)}
            onClick={resetFilters}
          >
            Réinitialiser
          </button>
          <button 
            className={cn("button", styles.button)}
            onClick={applyFilters}
          >
            Appliquer
          </button>
        </div>
      </div>
    </div>
  );
};

export default Settings;
